import apiClient from "./apiClient";

const roleMenuService = {
  async getMenusByRole(roleId) {
    const response = await apiClient.get(`/role-menus/role/${roleId}/menus`);
    return response.data?.data || response.data;
  },

  async getRolesByMenu(menuId) {
    const response = await apiClient.get(`/role-menus/menu/${menuId}/roles`);
    return response.data?.data || response.data;
  },

  async assignMenuToRole(roleId, menuId, permissions) {
    const response = await apiClient.post(`/role-menus/${roleId}/menus/${menuId}`, permissions);
    return response.data?.data || response.data;
  },

  async updateRoleMenuPermissions(roleId, menuId, permissions) {
    const response = await apiClient.patch(
      `/role-menus/${roleId}/menus/${menuId}/permissions`,
      permissions
    );
    return response.data?.data || response.data;
  },

  async updateBulkRoleMenuPermissions(roleId, permissionsData) {
    const payload = {
      permissions: (permissionsData || []).map((item) => ({
        menuId: Number(item.menuId),
        isRead: Boolean(item.isRead),
      })),
    };
    const response = await apiClient.post(`/role-menus/role/${roleId}/bulk-permissions`, payload);
    return response.data?.data || response.data;
  },

  async removeMenuFromRole(roleId, menuId) {
    const response = await apiClient.delete(`/role-menus/${roleId}/menus/${menuId}`);
    return response.data?.data || response.data;
  },
};

export default roleMenuService;
